import React from "react";
import OneSeriesByDiscoveryDate, {
  type OneSeriesByDiscoveryDateProps,
} from "./OneSeriesByDiscoveryDate";
import { oneSeriesTrendProperties } from "../TrendsUtils";

type OpenFindingsByDiscoveryDateProps = Pick<
  OneSeriesByDiscoveryDateProps,
  | "timeScale"
  | "selectedScope"
  | "filterToExecute"
  | "scopeToExecute"
  | "id"
  | "widgetKey"
  | "setIsReadyToExport"
>;

const OpenFindingsByDiscoveryDate: React.FC<
  OpenFindingsByDiscoveryDateProps
> = ({
  timeScale,
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  widgetKey,
  setIsReadyToExport = null,
}) => {
  return (
    <OneSeriesByDiscoveryDate
      widgetKey={widgetKey}
      timeScale={timeScale}
      chartData={oneSeriesTrendProperties.openFindingsByDiscoveryDate}
      scopeToExecute={scopeToExecute}
      filterToExecute={filterToExecute}
      selectedScope={selectedScope}
      id={id}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default OpenFindingsByDiscoveryDate;
